import { TYPE_NAMES } from "pages/marketing/marketingInitiatives/variables";

export const getSelectedFilterProp = filters => {
  if (filters[TYPE_NAMES.INITIATIVE_CODE]) return TYPE_NAMES.INITIATIVE_CODE;
  if (filters[TYPE_NAMES.STATUS]) return TYPE_NAMES.STATUS;
  return null;
};
